import { PasswordReset } from 'ui/components/company/patterns/PasswordReset/PasswordReset';

/**
 * パスワードリセットページ
 */
export const CompanyUserPasswordReset: React.FC = () => {
    return <PasswordReset />;
};
